import { useCallback } from "react";

import type { SnackSettings_SnackSettingsQuery } from "@/lib/gql/__generated__/graphql";

import { useSnackSettingsUpdateMutation } from "../../repository/mutation/use-snack-settings-update";
import { useCreateSnackLayoutSettingsFormModel } from "../use-create-snack-layout-settings-form-model";
import { useCreateSnackSettingsFormModel } from "../use-create-snack-settings-form-model";

type Props = {
	data: SnackSettings_SnackSettingsQuery;
};

export const useInit = ({ data }: Props) => {
	const { snackSettingsMethods, snackSettingsViewModel, resetSnackSettingsViewModel } =
		useCreateSnackSettingsFormModel({
			data: {
				...data.snackSettings,
				snackList: data.snackList,
				guestPageVisibilitySettings: data.guestPageVisibilitySettings,
			},
		});
	const { snackLayoutSettingsViewModel, snackLayoutSettingsMethods, resetSnackLayoutSettingsViewModel } =
		useCreateSnackLayoutSettingsFormModel({
			data: { ...data.snackBlocks, companyID: data.hotel.companyID, snackList: data.snackList },
		});

	const { onUpdate: _onUpdate } = useSnackSettingsUpdateMutation({
		resetSnackLayoutSettingsViewModel,
		resetSnackSettingsViewModel,
	});
	const onUpdate = useCallback(async () => {
		await _onUpdate({
			snackSettingsViewModel: snackSettingsViewModel,
			snackLayoutSettingsViewModel: snackLayoutSettingsViewModel,
			guestPageVisibilitySettings: data.guestPageVisibilitySettings,
		});
	}, [_onUpdate, data.guestPageVisibilitySettings, snackLayoutSettingsViewModel, snackSettingsViewModel]);

	const isValid =
		(snackSettingsViewModel.isDirty || snackLayoutSettingsViewModel.isDirty) && // どちらかが変更されていれば有効にする
		!snackSettingsViewModel.hasError &&
		!snackLayoutSettingsViewModel.hasError;

	return {
		onUpdate,

		snackSettingsViewModel,
		snackSettingsMethods,

		snackLayoutSettingsViewModel,
		snackLayoutSettingsMethods,

		isValid,
	};
};
